import { createAsyncThunk } from '@reduxjs/toolkit'
import i18n from 'i18next'

import { getLocales } from 'cng-common/features/translations/api'
import { history } from 'cng-common/helpers/routes/history'
import { deleteParamsFromUrl, getUrlParam } from 'core-components/helpers/url'
import { IUser } from 'core-components/sitebuilder/models/IUser'
import { updateCurrentUserGlobal } from 'core/hooks/services/useUserStore'
import { setUser } from 'core/store/appSlice'

import { getTranslations } from '../api/getTranslations'
import { NAME } from '../configs'
import { getTranslationParts } from '../helpers'
import { prepareTranslations } from '../helpers/prepareTranslations'
import { ILocale, ITranslationState } from '../models'
import { setLocale } from '../translationSlice'

export const changeTranslation = createAsyncThunk(
  `${NAME}/changeTranslation`,
  async (locale: ILocale, thunkApi) => {
    const state = thunkApi.getState() as { translations: ITranslationState; app: { user: IUser } }
    const dispatch = thunkApi.dispatch

    let newLocale = locale

    let userLocale = state.app?.user.locale
    const userLocales = state.app?.user.locales

    const urlLocale = getUrlParam('locale')
    if (urlLocale && urlLocale !== userLocale) {
      if (userLocales) {
        if (userLocales.find((el) => el === urlLocale)) {
          userLocale = urlLocale
        } else {
          history.replace(deleteParamsFromUrl(['locale']))
        }
      }

      const locales = await getLocales()
      const foundLocale = locales.find((el: ILocale) => el.value === userLocale)

      if (foundLocale) {
        newLocale = foundLocale
      }
    }

    const translation = await getTranslations(newLocale)
    const preparedTranslation = prepareTranslations(translation)

    i18n.addResourceBundle('0', 'translation', preparedTranslation, true, true)

    if (newLocale) {
      if (userLocale && userLocale !== newLocale.value) {
        const { languageCode } = getTranslationParts(newLocale)
        const updatedUser: IUser = {
          ...state.app.user,
          language: languageCode,
          locale: newLocale.value,
          locales: [...new Set([...userLocales, newLocale.value])],
        }

        dispatch(setUser(updatedUser))
        await updateCurrentUserGlobal(updatedUser)
      }

      dispatch(setLocale(newLocale))
    }
  }
)
